import React from 'react';
import { useFormContext } from 'react-hook-form';

const Step2Contact: React.FC = () => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <div className="solar-form-grid">
      <div className="solar-form-group">
        <label htmlFor="email" className="solar-form-label">
          Email
        </label>
        <input
          type="email"
          id="email"
          {...register('email')}
          className="solar-form-input"
        />
        {errors.email && (
          <p className="solar-form-error">{String(errors.email.message)}</p>
        )}
      </div>

      <div className="solar-form-group">
        <label htmlFor="phone" className="solar-form-label">
          Phone Number
        </label>
        <input
          type="tel"
          id="phone"
          {...register('phone')}
          className="solar-form-input"
        />
        {errors.phone && (
          <p className="solar-form-error">{String(errors.phone.message)}</p>
        )}
      </div>
    </div>
  );
};

export default Step2Contact; 